export const CHECKOUT_URL = 'https://cinnamon-roll-business.impultienda.ar/checkout'
export const OFFER_ANCHOR = '#offer'
export const PRODUCT_NAME = 'CINNAMON ROLL BUSINESS™'
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/3VQEZCk7QaT2w4qNg3baiC/ChatGPT-Image-25-ago-2026_-07_08_12-p.m..webp'
export const SUPPORT_EMAIL = 'kitonline27@gmail.com'
